import * as firebase from 'firebase/app';
import 'firebase/messaging';

const firebaseConfig = {
    apiKey: 'AIzaSyBJVmiOEmQiv5mAWfqqLh9EpJoCEK22MSo',
    authDomain: 'mizaem-e3d4f.firebaseapp.com',
    databaseURL: 'https://mizaem-e3d4f.firebaseio.com',
    projectId: 'mizaem-e3d4f',
    storageBucket: '',
    messagingSenderId: '151620810755',
    appId: '1:151620810755:web:f9977d9bb3d64fb8',
};

export const initializeFirebase = () => {
    firebase.initializeApp(firebaseConfig);
};

export const askForPermissions = async () => {
    try {
        const messaging = firebase.messaging();
        await messaging.requestPermission();
        const token = await messaging.getToken();
        return token;
    } catch (error) {
        console.error(error);
    }
};
